/* @flow */

export default {
  root: {
    width: 7,
    height: 9,

    transformOrigin: 'center center',
  },
  'root-right': {
    transform: 'rotate(180deg)',
  },
  'root-up': {
    /* Translation is needed because icon is not square */
    transform: 'translate(1px, -1px) rotate(90deg)',
  },
  'root-down': {
    /* Translation is needed because icon is not square */
    transform: 'translate(1px, -1px) rotate(-90deg)',
  },
};
